import React, { useState } from "react";
import { LifeBuoy, Phone, MessageSquareHeart } from "lucide-react";
import { ResponsiveModal } from "@/components/ui/responsive-modal";
import { CRISIS_RESOURCES, GROUNDING_STEPS } from "@/data/content";

export default function CrisisButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        data-testid="crisis-button"
        onClick={() => setOpen(true)}
        className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-terracotta px-5 py-3.5 text-sand shadow-soft-lg animate-pulse-soft transition-colors duration-300 hover:bg-terracotta-soft"
        aria-label="I need help now"
      >
        <LifeBuoy className="w-5 h-5" />
        <span className="font-medium hidden sm:inline">I need help now</span>
      </button>

      <ResponsiveModal
        open={open}
        onOpenChange={setOpen}
        testid="crisis-modal"
        icon={<div className="rounded-xl bg-terracotta/10 p-2 shrink-0"><LifeBuoy className="w-4 h-4 text-terracotta" /></div>}
        title="Take a breath. Help is here."
        description="You are not alone in this moment."
      >
        <div className="space-y-5 pb-2">
          <div className="rounded-2xl bg-sage p-5">
            <p className="font-scripture italic text-olive text-scripture leading-relaxed">
              “The Lord is close to the brokenhearted and saves those who are crushed in spirit.”
            </p>
            <p className="text-xs text-stone mt-2">Psalm 34:18</p>
          </div>

          <div className="space-y-2.5">
            {CRISIS_RESOURCES.map((r) => (
              <a
                key={r.name}
                href={`tel:${r.tel}`}
                data-testid={`crisis-resource-${r.tel}`}
                className="flex items-center gap-3 rounded-2xl border border-border bg-card p-4 transition-colors hover:bg-sage"
              >
                <div className="rounded-full bg-terracotta/10 p-2.5 shrink-0">
                  <Phone className="w-4 h-4 text-terracotta" />
                </div>
                <div className="min-w-0">
                  <p className="font-medium text-olive">{r.name}</p>
                  <p className="text-sm text-stone">{r.detail}</p>
                </div>
              </a>
            ))}
          </div>

          <div className="rounded-2xl border border-border p-4">
            <p className="flex items-center gap-2 font-medium text-olive mb-2">
              <MessageSquareHeart className="w-4 h-4 text-sky" /> A grounding exercise
            </p>
            <ol className="space-y-1.5 text-sm text-olive/80 list-decimal list-inside">
              {GROUNDING_STEPS.map((s, i) => (
                <li key={i}>{s}</li>
              ))}
            </ol>
          </div>
        </div>
      </ResponsiveModal>
    </>
  );
}
